import { Mail, MessageSquare } from 'lucide-react';

const ContactSection: React.FC = () => {
  return (
    <section
      className="py-20 bg-brand-900 text-white relative overflow-hidden"
      aria-labelledby="contact-heading"
    >
      {/* Abstract Background */}
      <div
        className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10"
        aria-hidden="true"
      >
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full mix-blend-overlay blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-brand-400 rounded-full mix-blend-overlay blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center">
        <h2 id="contact-heading" className="text-3xl md:text-4xl font-bold mb-6">
          Ready to automate your operations?
        </h2>
        <p className="text-xl text-brand-100 mb-10 max-w-2xl mx-auto">
          Whether you need specialized banking protocols like Velcron & Quandrex, or simple grocery
          inventory management, our architecture handles it all.
        </p>

        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="text-left">
              <h3 className="text-xl font-semibold mb-2 flex items-center">
                <MessageSquare className="mr-2" aria-hidden="true" /> Sales Inquiry
              </h3>
              <p className="text-brand-200 text-sm mb-4">
                For enterprise licensing and custom implementations.
              </p>
              <button
                type="button"
                className="w-full bg-white text-brand-900 py-3 rounded-lg font-bold hover:bg-brand-50 transition-colors cursor-pointer"
              >
                Contact Sales
              </button>
            </div>
            <div className="text-left border-t md:border-t-0 md:border-l border-white/20 pt-8 md:pt-0 md:pl-8">
              <h3 className="text-xl font-semibold mb-2 flex items-center">
                <Mail className="mr-2" aria-hidden="true" /> General Support
              </h3>
              <p className="text-brand-200 text-sm mb-4">
                Existing customers needing assistance with integration.
              </p>
              <button
                type="button"
                className="w-full bg-brand-700 text-white py-3 rounded-lg font-bold hover:bg-brand-600 transition-colors border border-brand-600 cursor-pointer"
              >
                Get Support
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
